import React from 'react';

// Variation 1: Code Monkey with SEO symbols (original)
export const CodeMonkeySEO = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="SEO Code Monkey">
      <title>SEO Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <ellipse cx="100" cy="105" rx="8" ry="6" fill="#8B7355"/>
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      <text x="20" y="30" fill="#FFD700" fontSize="16" fontFamily="monospace">&lt;/&gt;</text>
      <text x="160" y="30" fill="#C0C0C0" fontSize="14" fontFamily="monospace">{'{}'}</text>
      <text x="10" y="130" fill="#FFD700" fontSize="12" fontFamily="monospace">SEO</text>
      <text x="165" y="140" fill="#C0C0C0" fontSize="12" fontFamily="monospace">#1</text>
      <rect x="70" y="145" width="60" height="40" rx="10" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
    </svg>
  );
};

// Variation 2: Code Monkey with Link symbols
export const CodeMonkeyLinks = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Link Building Code Monkey">
      <title>Link Building Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      {/* Chain links */}
      <circle cx="30" cy="40" r="8" fill="none" stroke="#FFD700" strokeWidth="2"/>
      <circle cx="50" cy="40" r="8" fill="none" stroke="#FFD700" strokeWidth="2"/>
      <line x1="35" y1="40" x2="45" y2="40" stroke="#FFD700" strokeWidth="2"/>
      <circle cx="150" cy="140" r="8" fill="none" stroke="#C0C0C0" strokeWidth="2"/>
      <circle cx="170" cy="140" r="8" fill="none" stroke="#C0C0C0" strokeWidth="2"/>
      <line x1="155" y1="140" x2="165" y2="140" stroke="#C0C0C0" strokeWidth="2"/>
      <text x="10" y="170" fill="#FFD700" fontSize="11" fontFamily="monospace">LINK</text>
      <text x="155" y="30" fill="#C0C0C0" fontSize="11" fontFamily="monospace">DR50+</text>
    </svg>
  );
};

// Variation 3: Code Monkey with Analytics/Chart
export const CodeMonkeyAnalytics = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Analytics Code Monkey">
      <title>Analytics Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      {/* Chart bars */}
      <rect x="20" y="50" width="8" height="20" fill="#FFD700"/>
      <rect x="30" y="40" width="8" height="30" fill="#FFD700"/>
      <rect x="40" y="30" width="8" height="40" fill="#FFD700"/>
      <line x1="160" y1="30" x2="180" y2="50" stroke="#C0C0C0" strokeWidth="2"/>
      <line x1="180" y1="50" x2="170" y2="60" stroke="#C0C0C0" strokeWidth="2"/>
      <text x="12" y="85" fill="#FFD700" fontSize="10" fontFamily="monospace">DA</text>
      <text x="158" y="75" fill="#C0C0C0" fontSize="10" fontFamily="monospace">UP</text>
    </svg>
  );
};

// Variation 4: Code Monkey with Trophy (ranking)
export const CodeMonkeyTrophy = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Ranking Champion Code Monkey">
      <title>Ranking Champion Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <path d="M 88 115 Q 100 128 112 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      {/* Trophy */}
      <path d="M 30 30 L 35 50 L 25 50 Z" fill="#FFD700"/>
      <rect x="27" y="50" width="6" height="3" fill="#FFD700"/>
      <rect x="28" y="53" width="4" height="5" fill="#FFD700"/>
      <text x="162" y="35" fill="#FFD700" fontSize="18" fontFamily="monospace" fontWeight="bold">#1</text>
      <text x="8" y="72" fill="#FFD700" fontSize="9" fontFamily="monospace">WIN</text>
    </svg>
  );
};

// Variation 5: Code Monkey with Rocket (growth)
export const CodeMonkeyRocket = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Growth Rocket Code Monkey">
      <title>Growth Rocket Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      {/* Rocket */}
      <path d="M 170 30 L 175 50 L 165 50 Z" fill="#FFD700"/>
      <path d="M 165 50 L 170 45 L 175 50" fill="#C0C0C0"/>
      <path d="M 166 50 Q 170 55 174 50" fill="#FF6B6B"/>
      <text x="15" y="35" fill="#FFD700" fontSize="12" fontFamily="monospace">GROW</text>
      <text x="155" y="70" fill="#C0C0C0" fontSize="16" fontFamily="monospace">🚀</text>
    </svg>
  );
};

// Variation 6: Code Monkey with Dollar (monetization)
export const CodeMonkeyDollar = ({ size = 200 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Monetization Code Monkey">
      <title>Monetization Code Monkey</title>
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      {/* Dollar signs */}
      <text x="20" y="40" fill="#FFD700" fontSize="24" fontFamily="Arial" fontWeight="bold">$</text>
      <text x="165" y="145" fill="#FFD700" fontSize="24" fontFamily="Arial" fontWeight="bold">$</text>
      <circle cx="30" cy="150" r="10" fill="none" stroke="#C0C0C0" strokeWidth="2"/>
      <text x="26" y="156" fill="#C0C0C0" fontSize="12" fontFamily="monospace">$F</text>
    </svg>
  );
};

export default { CodeMonkeySEO, CodeMonkeyLinks, CodeMonkeyAnalytics, CodeMonkeyTrophy, CodeMonkeyRocket, CodeMonkeyDollar };
